<template>
  <div class="sidebar">
    <div class="sidebar-header" >
      <h3>服务平台</h3>
    </div>
    <el-menu
      :default-active="activeMenu"
      text-color="#333"
      active-text-color="#165DFF"
      ref="menu"
      @select="handleMenuSelect"
    >
      <template v-for="item in menuItems">
        <!-- 有子菜单的情况 -->
        <el-submenu
          v-if="item.childrenList && item.childrenList.length"
          :key="item.menuCode"
          :index="item.menuCode"
        >
          <template slot="title">
            <el-image
              v-if="getMenuIcon(item)"
              style="width: 13px;height: 13px;margin-right: 10px;"
              :src="getMenuIcon(item)"
            ></el-image>
            <i v-else class="el-icon-folder-opened" style="margin-right: 10px; color: #666;"></i>
            <span>{{ item.menuName }}</span>
          </template>
          <el-menu-item
            v-for="child in item.childrenList"
            :key="child.menuCode"
            :index="child.menuUrl"
          >
            <span slot="title">{{ child.menuName }}</span>
          </el-menu-item>
        </el-submenu>

        <!-- 无子菜单的情况 -->
        <el-menu-item
          v-else
          :key="item.menuCode"
          :index="item.menuUrl"
        >
          <el-image
            v-if="getMenuIcon(item)"
            style="width: 13px;height: 13px;margin-right: 10px;"
            :src="getMenuIcon(item)"
          ></el-image>
          <i v-else class="el-icon-menu" style="margin-right: 10px; color: #666;"></i>
          <span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { getMenuList } from '@/api/serviceDashbord'
export default {
  data() {
    return {
      menuItems: [],
      menuLoaded: false // 添加加载状态标识
    }
  },
  computed: {
    activeMenu() {
      const path = this.$route.path
      for (const item of this.menuItems) {
        if (item.childrenList && item.childrenList.length) {
          const child = item.childrenList.find(c => c.menuUrl === path)
          if (child) return child.menuUrl
        }
        if (item.menuUrl === path) return item.menuUrl
      }
      return path
    }
  },
  methods: {
    getMenuItems() {
      if (this.menuLoaded) return
      getMenuList().then(res => {
        const processedMenu = res.resultData.map(item => {
          const hasChildren = item.childrenList && item.childrenList.length
          const processedItem = {
            ...item,
            menuUrl: hasChildren ? item.menuCode : '/service/' + item.menuCode
          }
          if (hasChildren) {
            processedItem.childrenList = item.childrenList
              .sort((a, b) => a.menuSort - b.menuSort)
              .map(child => ({
                ...child,
                menuUrl: '/service/' + child.menuCode
              }))
          }
          return processedItem
        })
        // 存入Vuex和本地缓存
        this.$store.commit('SET_MENU', processedMenu)
        localStorage.setItem('cachedMenu', JSON.stringify(processedMenu))
        this.menuItems = processedMenu
      })
    },
    isMenuActive(item) {
      const path = this.$route.path
      if (item.childrenList && item.childrenList.length) {
        return item.childrenList.some(child => child.menuUrl === path)
      }
      return item.menuUrl === path
    },
    getMenuIcon(item) {
      const isActive = this.isMenuActive(item)
      const prefix = isActive ? 'activity' : ''
      try {
        return require(`@/static/images/service-icon/slideBar/${prefix}${item.menuCode}.png`)
      } catch (e) {
        return null
      }
    },
    handleMenuSelect(index) {
      // 判断是否是退出菜单
      const selectedMenu = this.menuItems.find(item => item.menuUrl === index)
      console.log(index, 'idex')
      if (selectedMenu && selectedMenu.menuCode === 'exit') {
        // 处理退出逻辑
        this.$store.dispatch('userOutLogin').then(() => {
          this.$router.push('/public/service/login')
        })
      } else {
        // 避免重复跳转到当前路径
        if (this.$route.path !== index) {
          this.$router.push(index)
        }
      }
    },
    // 初始化时优先从缓存读取
    initMenu() {
      const cached = localStorage.getItem('cachedMenu')
      if (cached) {
        this.menuItems = JSON.parse(cached)
        this.menuLoaded = true
      }
      this.getMenuItems() // 仍然请求最新数据
    }
  },
  watch: {
    '$route'(to) {
      // 只有当路由是/service下的路径时才保持菜单激活状态
      if (to.path.startsWith('/service')) {
        this.$nextTick(() => {
          // 强制更新菜单激活状态
          this.$refs.menu?.updateActiveIndex()
        })
      }
    }
  },
  mounted() {
    this.initMenu() // 修改初始化方法
  }
}
</script>

<style lang="scss" scoped>

.el-menu {
  border-right: none;
}
.sidebar {
  width: 200px;
  min-height: 80vh;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;

  background-image: url('../static/images/service-icon/leftMenu.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  border: 1px solid #E4E4E4; // 边框
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08); // 阴影
  border-radius: 8px; // 圆角
  transition: all 0.3s ease;
  .sidebar-header {
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    background: #045ad5;
    coLor: #fff;
    border-bottom: 1px solid #E4E4E4;
    h3 {
      margin: 0;
      padding: 0;
    }
  }
  .el-menu {
    /* 禁用菜单项的hover背景色 */
    background: transparent;
    .el-menu-item {
      &:hover {
        background-color: transparent !important;
      }
      
      /* 激活状态样式 */
      &.is-active {
        background-color: rgba(22, 93, 255, 0.1);
      }
    }
  }
}
</style>
